/* ByMoove - home : compteurs animes du bandeau chiffres (impact).
   Cible [class*="__stats"] .multicolumn-card__title. Repli sur repos si non parsable.
   Respecte prefers-reduced-motion. */
(function () {
  function grp(n) { return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }
  function animate(el) {
    if (el.dataset.bmCounted) return;
    var raw = el.textContent.trim();
    var m = raw.match(/^(\D*)(\d[\d\s.,  ]*\d|\d)(.*)$/);
    if (!m) return;
    var prefix = m[1], suffix = m[3];
    var target = parseInt(m[2].replace(/\D/g, ''), 10);
    if (isNaN(target)) return;
    el.dataset.bmCounted = '1';
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = prefix + grp(target) + suffix; return;
    }
    var dur = 1500, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + grp(Math.round(eased * target)) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = prefix + grp(target) + suffix;
    }
    requestAnimationFrame(step);
  }
  function run() {
    var sec = document.querySelector('[class*="__stats"]');
    if (!sec) return;
    var els = sec.querySelectorAll('.multicolumn-card__title');
    if (!els.length) return;
    function fire() { els.forEach(animate); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { fire(); io.disconnect(); } });
      }, { threshold: 0.4 });
      io.observe(sec);
    } else { fire(); }
  }
  /* Produit "prix sur devis" (devis_obligatoire) : bouton Demander un devis
     -> ajoute au panier avec la propriété _devis puis va sur /pages/mon-devis. */
  function wireDevisOblig() {
    var btn = document.getElementById('bymoove-ask-devis');
    if (!btn || btn.dataset.bmWired) return;
    btn.dataset.bmWired = '1';
    btn.addEventListener('click', function () {
      var v = btn.getAttribute('data-variant');
      btn.disabled = true;
      function go() { window.location.href = '/pages/mon-devis'; }
      if (!v) { go(); return; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(v), quantity: 1, properties: { _devis: '1' } }] }) })
        .then(go).catch(go);
    });
  }
  /* Formulaires de contact/devis : consentement RGPD + anti-spam honeypot (global). */
  function hardenContactForms() {
    var forms = document.querySelectorAll('form[action*="/contact"]');
    forms.forEach(function (form) {
      if (form.dataset.bmHardened) return;
      var ft = form.querySelector('input[name="form_type"]');
      if (ft && ft.value !== 'contact') return; // newsletter (customer) : pas de case devis
      form.dataset.bmHardened = '1';
      // honeypot (piege a bots)
      var hp = document.createElement('div');
      hp.setAttribute('aria-hidden', 'true');
      hp.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden;';
      hp.innerHTML = '<input type="text" name="contact[site_web]" tabindex="-1" autocomplete="off">';
      form.appendChild(hp);
      // consentement RGPD
      var submit = form.querySelector('[type="submit"], button[name="commit"], button:not([type="button"])');
      var consent = document.createElement('label');
      consent.className = 'bymoove-consent';
      consent.style.cssText = 'display:flex;align-items:flex-start;gap:8px;margin:14px 0;font-size:.88rem;color:#2a3542;text-align:left;';
      consent.innerHTML = '<input type="checkbox" class="bymoove-consent-box" style="margin-top:2px;accent-color:#36ae9b;flex:none;"> <span>J\'accepte que mes informations soient utilisees pour traiter ma demande. <a href="/pages/politique-confidentialite" target="_blank" rel="noopener" style="text-decoration:underline;">Politique de confidentialite</a>.</span>';
      if (submit && submit.parentNode) submit.parentNode.insertBefore(consent, submit);
      form.addEventListener('submit', function (e) {
        var bot = form.querySelector('[name="contact[site_web]"]');
        if (bot && bot.value) { e.preventDefault(); return; }
        var box = form.querySelector('.bymoove-consent-box');
        if (box && !box.checked) {
          e.preventDefault();
          box.focus();
          consent.style.color = '#c0392b';
          if (!consent.querySelector('.bymoove-consent-err')) {
            var er = document.createElement('em'); er.className = 'bymoove-consent-err'; er.style.cssText = 'display:block;color:#c0392b;font-style:normal;margin-top:4px;'; er.textContent = 'Merci de cocher cette case pour envoyer votre demande.';
            consent.appendChild(er);
          }
          return;
        }
        var body = form.querySelector('textarea[name="contact[body]"], textarea[name*="[body]"]');
        if (body && body.value.indexOf('Consentement') === -1) { body.value += '\n\nConsentement : accepte.'; }
      });
    });
  }

  /* Non-pro : achat en ligne reserve aux pros -> bouton d'ajout = 'Ajouter au devis' + note. */
  function relabelForNonPro() {
    if (!window.BM_NONPRO) return;
    var ADD = /panier|cart|ajouter/i, SKIP = /rupture|épuis|epuis|sold|indispo|coming|pré-?comm|precomm/i;
    function ownText(el) { var t = ''; for (var n = el.firstChild; n; n = n.nextSibling) { if (n.nodeType === 3) t += n.nodeValue; } return t.trim(); }
    function setOwnText(el, val) { var done = false; for (var n = el.firstChild; n; n = n.nextSibling) { if (n.nodeType === 3 && n.nodeValue.trim()) { if (!done) { n.nodeValue = val; done = true; } else { n.nodeValue = ''; } } } if (!done) el.appendChild(document.createTextNode(val)); }
    function fix(btn) {
      var cand = [].slice.call(btn.querySelectorAll('span')); cand.push(btn);
      for (var i = 0; i < cand.length; i++) { var el = cand[i]; if (el.classList && el.classList.contains('visually-hidden')) continue; var own = ownText(el); if (own && ADD.test(own) && !SKIP.test(own) && own !== 'Ajouter au devis') { setOwnText(el, 'Ajouter au devis'); return; } }
    }
    document.querySelectorAll('form[action*="/cart/add"] [type="submit"], product-form [type="submit"], .product-form__submit').forEach(function (btn) {
      if (btn.getAttribute('name') === 'checkout') return;
      fix(btn);
      if (!btn.dataset.bmObs) { btn.dataset.bmObs = '1'; new MutationObserver(function () { fix(btn); }).observe(btn, { childList: true, subtree: true, characterData: true }); }
    });
    var bb = document.querySelector('.product__block--buy_buttons');
    if (bb && !document.querySelector('.bymoove-nonpro-hint')) {
      var p = document.createElement('p'); p.className = 'bymoove-nonpro-hint';
      p.style.cssText = 'font-size:.85rem;line-height:1.45;color:#5b4a2e;background:#fff7ec;border:1px solid #f3e2c3;border-radius:10px;padding:10px 12px;margin:10px 0 0;';
      p.textContent = 'Achat en ligne réservé aux comptes pros connectés. Ajoutez au devis puis validez votre demande (réponse sous 24 h).';
      bb.appendChild(p);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); wireDevisOblig(); hardenContactForms(); relabelForNonPro(); });
  else { run(); wireDevisOblig(); hardenContactForms(); relabelForNonPro(); }
})();
